export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  imageUrl: string;
  author: string;
  publishDate: string;
  readTime: string;
  tags: string[];
}

export interface Category {
  slug: string;
  name: string;
  description: string;
  imageUrl: string;
  articleCount: number;
}

export interface Testimonial {
  name: string;
  role: string;
  content: string;
  avatarUrl: string;
}

export const siteConfig = {
  name: '白丝时尚网',
  description: '白色丝袜穿搭指南与时尚资讯平台',
  url: 'https://baisifashion.com',
  email: 'contact@baisifashion.com',
  phone: '400-888-6666',
  address: '上海市静安区南京西路1266号恒隆广场18楼',
  wechat: 'baisifashion_official',
};

export const categories: Category[] = [
  {
    slug: 'daily-wear',
    name: '日常穿搭',
    description: '日常生活中的白丝搭配灵感，从通勤到休闲，让你每一天都优雅动人。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20young%20woman%20in%20white%20stockings%20casual%20daily%20outfit%20walking%20on%20city%20street%20in%20sunlight%2C%20natural%20pose%2C%20fashion%20blog%20photography%20style%2C%20soft%20warm%20lighting%2C%20clean%20urban%20background%20with%20minimal%20architecture%2C%20editorial%20fashion%20shoot%2C%20cream%20and%20beige%20color%20palette&width=800&height=600&seq=cat-daily-01&orientation=landscape',
    articleCount: 42,
  },
  {
    slug: 'dating-look',
    name: '约会穿搭',
    description: '约会场合的白丝搭配方案，甜美与优雅兼备，展现迷人魅力。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20wearing%20white%20stockings%20and%20romantic%20dress%20at%20upscale%20restaurant%20candlelit%20dinner%20setting%2C%20soft%20warm%20ambient%20lighting%2C%20fashion%20editorial%20style%20photography%2C%20elegant%20and%20feminine%20aesthetic%2C%20cream%20and%20rose%20gold%20tones&width=800&height=600&seq=cat-dating-01&orientation=landscape',
    articleCount: 28,
  },
  {
    slug: 'office-style',
    name: '职场穿搭',
    description: '职场白丝穿搭法则，干练与时尚兼得，展现专业气质。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20woman%20in%20white%20stockings%20and%20tailored%20business%20attire%20in%20modern%20office%20with%20natural%20light%20from%20large%20windows%2C%20confident%20pose%2C%20clean%20minimalist%20workspace%2C%20fashion%20editorial%20photography%2C%20soft%20neutral%20color%20palette&width=800&height=600&seq=cat-office-01&orientation=landscape',
    articleCount: 35,
  },
  {
    slug: 'product-review',
    name: '产品评测',
    description: '热门白丝品牌深度评测，帮你找到最适合的那一双。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautifully%20arranged%20white%20stockings%20and%20hosiery%20products%20flat%20lay%20on%20marble%20surface%20with%20flowers%20and%20fashion%20accessories%2C%20product%20photography%20style%2C%20soft%20natural%20lighting%2C%20elegant%20minimalist%20composition%2C%20cream%20and%20white%20aesthetic&width=800&height=600&seq=cat-review-01&orientation=landscape',
    articleCount: 56,
  },
  {
    slug: 'care-tips',
    name: '保养技巧',
    description: '白丝保养与护理全攻略，延长丝袜寿命，保持洁白如新。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Delicate%20white%20stockings%20being%20gently%20hand%20washed%20in%20elegant%20bathroom%20setting%20with%20soft%20natural%20light%2C%20luxury%20home%20spa%20aesthetic%2C%20minimalist%20interior%20design%2C%20clean%20white%20and%20cream%20color%20scheme%2C%20lifestyle%20photography&width=800&height=600&seq=cat-care-01&orientation=landscape',
    articleCount: 19,
  },
  {
    slug: 'trend-report',
    name: '潮流趋势',
    description: '全球白丝时尚潮流追踪，掌握最新流行风向标。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fashion%20runway%20show%20featuring%20models%20wearing%20white%20stockings%20with%20designer%20outfits%2C%20dramatic%20stage%20lighting%2C%20high%20fashion%20editorial%20style%2C%20modern%20runway%20setting%2C%20elegant%20and%20sophisticated%20aesthetic%2C%20cream%20and%20champagne%20tones&width=800&height=600&seq=cat-trend-01&orientation=landscape',
    articleCount: 23,
  },
];

export const articles: Article[] = [
  {
    slug: 'white-stockings-spring-2026-trend',
    title: '2026春季白丝穿搭趋势：轻盈质感引领新风潮',
    excerpt: '2026年春季，白丝穿搭迎来了全新的设计理念和搭配方式。本文为您详细解析本季白丝流行趋势，从材质选择到色彩搭配，教你如何穿出春日轻盈感。',
    content: `<p>随着2026年春季的到来，白丝穿搭迎来了全新的设计理念和搭配方式。本季白丝的设计重点在于<strong>轻盈质感</strong>和<strong>自然通透</strong>，告别厚重的冬季风格，迎接清新优雅的春日气息。</p>
<h2>一、2026春季白丝材质新趋势</h2>
<p>今年春季，超薄透肤系列成为主流。采用新型微纤维技术的白丝，厚度仅为5D-10D，几乎隐形的同时又能均匀肤色，让双腿呈现自然的柔焦效果。高端品牌如Wolford、Calzedonia纷纷推出春季限定款，主打<strong>裸感穿着体验</strong>。</p>
<p>另外，环保材质也成为本季亮点。再生尼龙制成的白丝不仅环保，触感更加柔软丝滑，受到越来越多时尚达人的青睐。</p>
<h2>二、色彩搭配新法则</h2>
<p>2026春季白丝的色彩搭配更加大胆多元。除了经典的纯白色系，<strong>米白色、奶油白、珍珠白</strong>等暖调白色成为热门之选。搭配方面，浅色系连衣裙、奶茶色风衣、淡粉针织衫都是绝佳搭档。</p>
<p>特别值得关注的是，白色丝袜与金属色单品的碰撞——银色高跟鞋或金色手包，能瞬间提升整体造型的时髦度。</p>
<h2>三、热门搭配方案推荐</h2>
<p><strong>1. 法式优雅风：</strong>米白丝袜 + 碎花茶歇裙 + 裸色尖头鞋，约会逛街两相宜。</p>
<p><strong>2. 简约通勤风：</strong>珍珠白丝袜 + 米色西装套装 + 白色乐福鞋，职场也能时尚满分。</p>
<p><strong>3. 甜酷混搭风：</strong>纯白丝袜 + 黑色皮质短裙 + 马丁靴，打造反差感十足的个性造型。</p>
<h2>四、选购建议</h2>
<p>购买春季白丝时，建议关注以下几点：选择带有<strong>防勾丝技术</strong>的产品；根据肤色选择合适白度——冷白皮选纯白，暖黄皮选米白；关注袜口设计，无痕宽边款穿着更舒适。</p>`,
    category: 'trend-report',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20young%20woman%20wearing%20sheer%20white%20stockings%20and%20spring%20pastel%20dress%20in%20blooming%20flower%20garden%20with%20soft%20sunlight%2C%20fashion%20editorial%20photography%2C%20dreamy%20spring%20aesthetic%2C%20cream%20and%20blush%20pink%20tones%2C%20natural%20elegant%20pose&width=1200&height=675&seq=article-spring-01&orientation=landscape',
    author: '林小雨',
    publishDate: '2026-03-15',
    readTime: '8分钟',
    tags: ['春季穿搭', '潮流趋势', '白丝搭配', '2026新款'],
  },
  {
    slug: 'white-stockings-office-guide',
    title: '职场白丝穿搭完全指南：得体与时尚的完美平衡',
    excerpt: '在职场中如何穿搭白丝才能既得体又时尚？本文从场合、搭配、礼仪三个维度，为你提供全面的职场白丝穿搭建议，让你在办公室也能优雅出众。',
    content: `<p>职场穿搭向来是一门需要拿捏分寸的艺术，而白丝作为其中的点睛之笔，更是需要精心搭配。今天我们就来聊聊如何在职场中穿搭白丝，做到<strong>得体与时尚的完美平衡</strong>。</p>
<h2>一、不同职场场合的白丝选择</h2>
<p><strong>正式商务会议：</strong>建议选择8D-15D的超薄哑光白丝，搭配深色西装套裙，低调中彰显专业。避免选择过白或反光度过高的款式。</p>
<p><strong>日常办公：</strong>20D-30D的微压白丝是最佳选择，既能修饰腿型，又不会过于厚重。搭配A字裙或烟管裤都很合适。</p>
<p><strong>公司年会/晚宴：</strong>可以选择带有细腻光泽感的白丝，搭配礼服裙，在正式场合中展现优雅魅力。</p>
<h2>二、职场白丝穿搭黄金法则</h2>
<p><strong>法则一：颜色要自然。</strong>职场白丝建议选择与肤色接近的米白色或奶白色，而非纯白。纯白丝袜在办公室光线下容易显得突兀。</p>
<p><strong>法则二：厚度要适中。</strong>夏季选择5D-10D超薄款，秋冬可选15D-30D。超过40D的白丝在职场环境中会显得过于休闲。</p>
<p><strong>法则三：搭配要简约。</strong>白丝本身就很吸睛，服装搭配应以简约为主，避免过于花哨的图案和装饰。</p>
<h2>三、推荐品牌与单品</h2>
<p>职场白丝首推<strong>Wolford Pure 10</strong>系列，哑光质感非常适合商务场合。价格亲民的<strong>Calzedonia</strong>和<strong>Uniqlo</strong>也有不错的职场白丝选择。</p>`,
    category: 'office-style',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20woman%20in%20elegant%20white%20stockings%20and%20tailored%20business%20attire%20standing%20confidently%20in%20modern%20office%20with%20glass%20walls%20and%20natural%20light%2C%20fashion%20editorial%20photography%2C%20minimalist%20corporate%20aesthetic&width=1200&height=675&seq=article-office-01&orientation=landscape',
    author: '王雅婷',
    publishDate: '2026-02-28',
    readTime: '10分钟',
    tags: ['职场穿搭', '白丝搭配', '办公室时尚', '穿搭指南'],
  },
  {
    slug: 'top-10-white-stockings-2026',
    title: '2026年度十大白丝品牌评测：从平价到高端全面对比',
    excerpt: '我们实测了市面上最热门的十个白丝品牌，从舒适度、耐穿性、性价比等多个维度进行深度对比，帮你挑选最适合的白丝产品。',
    content: `<p>白丝市场品牌众多，价格从几十元到上千元不等，如何挑选最适合自己的那一款？本期我们实测了<strong>十大热门白丝品牌</strong>，为你带来最全面的选购参考。</p>
<h2>评测维度说明</h2>
<p>本次评测从以下五个维度进行打分（满分10分）：<strong>舒适度、耐穿性、透肤度、色彩表现、性价比</strong>。测试团队由三位不同肤色的编辑组成，确保评测结果的客观性。</p>
<h2>TOP 10 榜单</h2>
<p><strong>第1名：Wolford Pure 10 - 综合评分 9.2</strong><br/>奥地利顶级品牌，哑光质感无可挑剔，舒适度满分。唯一的缺点就是价格偏高，一双约380元。</p>
<p><strong>第2名：Calzedonia Sheer White - 综合评分 8.8</strong><br/>意大利国民品牌，性价比极高。透肤自然，适合日常穿着。价格约120元/双。</p>
<p><strong>第3名：Falke Pure Matt 15 - 综合评分 8.6</strong><br/>德国老牌，耐穿性出色。特别添加防勾丝技术，使用寿命是普通白丝的2-3倍。价格约250元/双。</p>
<p><strong>第4名：Uniqlo Sheer White - 综合评分 8.2</strong><br/>性价比之王，79元/双的价格却有不错的表现。适合学生党和预算有限的消费者。</p>
<p><strong>第5名：Aristoc Ultra Sheer - 综合评分 8.0</strong><br/>英国经典品牌，色彩表现出众，白度非常纯净。价格约180元/双。</p>`,
    category: 'product-review',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ten%20pairs%20of%20white%20stockings%20elegantly%20arranged%20on%20white%20marble%20surface%20flat%20lay%20photography%20with%20brand%20labels%2C%20product%20comparison%20display%2C%20soft%20natural%20lighting%2C%20clean%20minimalist%20aesthetic%2C%20luxury%20product%20photography&width=1200&height=675&seq=article-review-01&orientation=landscape',
    author: '陈思琪',
    publishDate: '2026-03-10',
    readTime: '12分钟',
    tags: ['产品评测', '白丝推荐', '品牌对比', '购物指南'],
  },
  {
    slug: 'white-stockings-dating-style',
    title: '约会穿搭小心机：白丝让你成为全场焦点',
    excerpt: '约会穿什么永远是女生最关心的话题。白丝作为约会穿搭的秘密武器，如何搭配才能既甜美又不失优雅？本文为你揭晓答案。',
    content: `<p>约会穿搭中，白丝是<strong>提升气质的神器</strong>。它能让双腿看起来更加修长白皙，同时散发出温柔优雅的女性魅力。今天就来分享约会白丝穿搭的秘诀。</p>
<h2>一、不同约会场景的白丝搭配</h2>
<p><strong>浪漫晚餐：</strong>小黑裙 + 超薄白丝 + 细高跟，经典不败的法式优雅。搭配一条珍珠项链更添精致感。</p>
<p><strong>咖啡约会：</strong>针织衫 + A字裙 + 米白丝袜 + 芭蕾平底鞋，温柔甜美又不刻意。</p>
<p><strong>户外散步：</strong>连衣裙 + 薄款白丝 + 小白鞋，清新自然，少女感拉满。</p>
<h2>二、白丝约会穿搭禁忌</h2>
<p>❌ 忌搭配过于暴露的服装——白丝本身就具有吸引力，过度暴露会显得不够得体。</p>
<p>❌ 忌选择过厚的白丝——约会场合建议选择10D以下的超薄款。</p>
<p>❌ 忌忽略鞋子搭配——白丝与鞋子的搭配至关重要，避免深色厚重鞋款。</p>
<h2>三、约会白丝小贴士</h2>
<p>随身携带一双备用白丝，以防勾丝尴尬。选择带有<strong>脚尖透明设计</strong>的款式，穿露趾鞋也很好看。</p>`,
    category: 'dating-look',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20in%20white%20stockings%20and%20romantic%20dress%20at%20candlelit%20dinner%20restaurant%20with%20warm%20ambient%20lighting%2C%20intimate%20atmosphere%2C%20fashion%20editorial%20photography%2C%20soft%20rose%20gold%20and%20cream%20tones&width=1200&height=675&seq=article-dating-01&orientation=landscape',
    author: '林小雨',
    publishDate: '2026-03-05',
    readTime: '7分钟',
    tags: ['约会穿搭', '白丝搭配', '甜美风格', '约会技巧'],
  },
  {
    slug: 'white-stockings-care-guide',
    title: '白丝保养终极指南：5个技巧让你的丝袜寿命延长3倍',
    excerpt: '白丝容易勾丝、发黄是很多人的困扰。本文分享5个专业保养技巧，从清洗、晾晒到收纳，帮你延长白丝使用寿命。',
    content: `<p>白丝是消耗品没错，但正确的保养方法能让它的寿命<strong>延长2-3倍</strong>。今天就来分享专业白丝保养师都在用的5个技巧。</p>
<h2>技巧一：手洗是王道</h2>
<p>切勿将白丝放入洗衣机！用30℃以下的温水和中性洗涤剂，<strong>轻柔手洗</strong>。浸泡时间不超过5分钟，避免纤维受损。</p>
<h2>技巧二：晾晒有讲究</h2>
<p>白丝绝对不能暴晒！紫外线会导致纤维老化发黄。应该<strong>阴凉通风处晾干</strong>，用毛巾轻轻吸干多余水分后平铺晾晒。</p>
<h2>技巧三：正确收纳</h2>
<p>将白丝卷起而非折叠，避免产生难以消除的折痕。最好放在<strong>独立的收纳袋</strong>中，防止与其他衣物摩擦勾丝。</p>
<h2>技巧四：穿前预处理</h2>
<p>新买的丝袜可以先放在冰箱冷冻室<strong>冷冻24小时</strong>，低温能增强纤维韧性，减少勾丝概率。</p>
<h2>技巧五：应急修复法</h2>
<p>轻微勾丝时，立即涂抹<strong>透明指甲油</strong>在勾丝处，防止扩大。随身携带一小瓶备用。</p>`,
    category: 'care-tips',
    imageUrl: 'https://readdy.ai/api/search-image?query=Delicate%20white%20stockings%20being%20gently%20hand%20washed%20in%20elegant%20marble%20bathroom%20with%20soft%20natural%20morning%20light%2C%20luxury%20home%20spa%20aesthetic%2C%20lifestyle%20photography%2C%20cream%20and%20white%20color%20scheme&width=1200&height=675&seq=article-care-01&orientation=landscape',
    author: '张美琳',
    publishDate: '2026-02-20',
    readTime: '6分钟',
    tags: ['丝袜保养', '白丝护理', '生活技巧', '延长寿命'],
  },
  {
    slug: 'white-stockings-daily-style-ideas',
    title: '一周白丝穿搭日记：7天不重样的日常搭配灵感',
    excerpt: '白丝不只是正式场合的专属。本文记录了一周7天的白丝日常穿搭，从周一通勤到周日休闲，给你满满的搭配灵感。',
    content: `<p>很多人觉得白丝只适合正式场合，其实不然。<strong>日常穿搭中巧用白丝</strong>，能让整体造型瞬间提升一个档次。今天就来看看一周7天的白丝穿搭日记。</p>
<h2>周一：干练通勤</h2>
<p>米白丝袜 + 深蓝西装 + 白色衬衫 + 黑色尖头鞋，经典永不过时。</p>
<h2>周二：温柔知性</h2>
<p>珍珠白丝袜 + 驼色针织裙 + 同色系短靴，温柔又知性。</p>
<h2>周三：法式简约</h2>
<p>超薄白丝 + 条纹衫 + 牛仔裤 + 红色芭蕾鞋，轻松演绎法式风情。</p>
<h2>周四：甜酷混搭</h2>
<p>纯白丝袜 + 黑色皮裙 + 宽松卫衣 + 马丁靴，甜酷风格信手拈来。</p>
<h2>周五：约会准备</h2>
<p>米白丝袜 + 碎花连衣裙 + 细带凉鞋，下班直接去约会。</p>
<h2>周六：慵懒周末</h2>
<p>白丝 +  oversized针织衫 + 短裤 + 帆布鞋，慵懒又时髦。</p>
<h2>周日：精致下午茶</h2>
<p>珍珠白丝袜 + 小香风套装 + 珍珠配饰，下午茶拍照超出片。</p>`,
    category: 'daily-wear',
    imageUrl: 'https://readdy.ai/api/search-image?query=Young%20woman%20in%20white%20stockings%20and%20casual%20stylish%20outfit%20walking%20on%20sunny%20city%20street%20with%20coffee%20cup%2C%20natural%20lifestyle%20photography%2C%20warm%20morning%20light%2C%20urban%20background%2C%20fashion%20blogger%20style&width=1200&height=675&seq=article-daily-01&orientation=landscape',
    author: '王雅婷',
    publishDate: '2026-03-01',
    readTime: '9分钟',
    tags: ['日常穿搭', '白丝搭配', '一周穿搭', '搭配灵感'],
  },
  {
    slug: 'white-stockings-for-different-body-types',
    title: '不同腿型如何选白丝？量身定制的选购指南',
    excerpt: '不同腿型适合不同款式的白丝。本文从腿型分类入手，告诉你如何根据自己的身材特点挑选最修饰腿型的白丝产品。',
    content: `<p>选对白丝，<strong>显瘦显腿长</strong>效果堪比修图。但不同腿型适合的款式也不同。今天就来看看如何根据自己的腿型选择最合适的白丝。</p>
<h2>一、标准腿型</h2>
<p>恭喜你！几乎所有款式的白丝都能驾驭。建议尝试<strong>各种流行款</strong>，展现你的美腿优势。</p>
<h2>二、O型腿</h2>
<p>选择<strong>哑光白丝</strong>，避免反光款式。建议选择20D-30D的微压款，能适度修饰腿型。搭配长裙或阔腿裤效果更佳。</p>
<h2>三、X型腿</h2>
<p>选择<strong>带有竖纹纹理</strong>的白丝，能视觉拉直腿型。避免过薄款式，15D以上更合适。</p>
<h2>四、小腿粗壮</h2>
<p>选择<strong>渐进压力款白丝</strong>，从脚踝到大腿压力递减，有效修饰小腿线条。深米白色优于纯白色。</p>
<h2>五、腿型偏瘦</h2>
<p>选择<strong>带有微光泽</strong>的白丝，增加立体感。15D-20D的中等厚度能让腿部看起来更饱满。</p>`,
    category: 'product-review',
    imageUrl: 'https://readdy.ai/api/search-image?query=Three%20fashionable%20women%20of%20different%20body%20types%20all%20elegantly%20wearing%20white%20stockings%20with%20different%20outfits%20in%20bright%20modern%20studio%2C%20fashion%20editorial%20photography%2C%20inclusive%20beauty%20concept%2C%20warm%20lighting&width=1200&height=675&seq=article-body-01&orientation=landscape',
    author: '陈思琪',
    publishDate: '2026-02-15',
    readTime: '8分钟',
    tags: ['选购指南', '腿型修饰', '白丝推荐', '穿搭技巧'],
  },
  {
    slug: 'white-stockings-summer-guide',
    title: '夏日白丝穿搭攻略：轻薄透气不闷热的秘诀',
    excerpt: '夏天穿白丝会不会太热？选对材质和款式，夏季也能清爽穿搭白丝。本文分享夏季白丝选择与搭配的全方位攻略。',
    content: `<p>很多人认为夏天不适合穿白丝，其实选对材质和款式，<strong>夏季也能清爽穿搭</strong>。今天就来看看夏日白丝的挑选和搭配秘诀。</p>
<h2>一、夏季白丝材质选择</h2>
<p>夏季白丝首选<strong>超薄冰丝材质</strong>，厚度控制在3D-8D之间。冰丝面料自带凉感，透气性极佳，穿着几乎感觉不到它的存在。</p>
<p>另外，<strong>镂空花纹款</strong>也是夏季热门选择，透气的同时还能增添时尚感。</p>
<h2>二、夏季白丝搭配建议</h2>
<p><strong>短裙/短裤 + 白丝：</strong>夏天最常见的搭配方式，青春活力满分。</p>
<p><strong>吊带裙 + 白丝：</strong>清凉又性感，约会逛街都适合。</p>
<p><strong>T恤裙 + 白丝：</strong>慵懒随性，搭配帆布鞋轻松出街。</p>
<h2>三、夏季穿白丝的注意事项</h2>
<p>1. 出汗后及时更换，避免细菌滋生。</p>
<p>2. 穿前涂抹爽身粉，保持干爽。</p>
<p>3. 选择浅色内衣裤，避免透色尴尬。</p>`,
    category: 'daily-wear',
    imageUrl: 'https://readdy.ai/api/search-image?query=Young%20woman%20in%20sheer%20white%20stockings%20and%20light%20summer%20dress%20enjoying%20sunny%20day%20at%20outdoor%20cafe%20with%20greenery%2C%20fresh%20summer%20aesthetic%2C%20natural%20sunlight%2C%20fashion%20lifestyle%20photography&width=1200&height=675&seq=article-summer-01&orientation=landscape',
    author: '林小雨',
    publishDate: '2026-06-20',
    readTime: '7分钟',
    tags: ['夏季穿搭', '白丝搭配', '清凉穿搭', '季节指南'],
  },
];

export const testimonials: Testimonial[] = [
  {
    name: '林小雨',
    role: '时尚编辑',
    content: '白丝时尚网是我每天必看的网站，内容专业又实用，帮我解决了很多穿搭困惑。尤其是产品评测栏目，每次买丝袜前都会先来看看。',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20Chinese%20woman%20with%20elegant%20style%2C%20fashion%20editor%20headshot%2C%20soft%20natural%20lighting%2C%20minimalist%20cream%20background%2C%20professional%20yet%20friendly%20expression&width=200&height=200&seq=avatar-01&orientation=squarish',
  },
  {
    name: '张美琳',
    role: '美妆博主',
    content: '自从关注了白丝时尚网，我的粉丝都说我穿搭越来越有品位了。这里的搭配灵感真的很棒，强烈推荐给所有爱美的女生！',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20woman%20portrait%20with%20warm%20smile%2C%20beauty%20blogger%20headshot%2C%20soft%20diffused%20lighting%2C%20minimalist%20beige%20background%2C%20friendly%20and%20approachable%20look&width=200&height=200&seq=avatar-02&orientation=squarish',
  },
  {
    name: '陈思琪',
    role: '职场白领',
    content: '作为一个每天需要穿正装的职场人，白丝时尚网的职场穿搭栏目给了我很多灵感。现在同事们都夸我穿得有品位！',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%20in%20business%20attire%2C%20confident%20headshot%2C%20clean%20studio%20lighting%2C%20minimalist%20white%20background%2C%20professional%20corporate%20style&width=200&height=200&seq=avatar-03&orientation=squarish',
  },
];